import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col-6 flex align-items-center" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "col-4" }
const _hoisted_4 = { class: "size font-light" }

import { FileInterface } from '@/types';
import { EMIT } from '@/enum';
import { toRefs } from 'vue';

interface Props {
  file: FileInterface;
  tag?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FilePreview',
  props: {
    file: {},
    tag: { default: 'li' }
  },
  setup(__props: any, { emit: __emit }) {

const props = __props;
const { file, tag } = toRefs(props);

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(tag)), { class: "file-preview relative" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "material-icons drive w-1rem mx-3" }, "insert_drive_file", -1)),
        _createElementVNode("span", {
          class: "title font-light my-0 mx-1",
          textContent: _toDisplayString(_unref(file).file.name)
        }, null, 8, _hoisted_2)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(file).file.size) + " KB", 1)
      ]),
      _createElementVNode("div", {
        class: "close absolute right-0 my-0 mx-1 cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit(_unref(EMIT).REMOVE, _unref(file))))
      }, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("span", { class: "material-icons" }, "close", -1)
      ]))])
    ]),
    _: 1
  }))
}
}

})